import { apiClient } from "@/shared/api/client"
import type { FarmResponse, FarmCreateRequest, FarmMemberResponse } from "@/shared/types/api"

export const farmsApi = {
  list: async (): Promise<FarmResponse[]> => {
    const response = await apiClient.get<{ data: FarmResponse[] }>("/farms")
    return response.data.data || []
  },

  get: async (farmId: string): Promise<FarmResponse> => {
    const response = await apiClient.get<{ data: FarmResponse }>(`/farms/${farmId}`)
    return response.data.data
  },

  create: async (data: FarmCreateRequest): Promise<FarmResponse> => {
    const response = await apiClient.post<{ data: FarmResponse }>("/farms", data)
    return response.data.data
  },

  update: async (farmId: string, data: Partial<FarmCreateRequest>): Promise<FarmResponse> => {
    const response = await apiClient.put<{ data: FarmResponse }>(`/farms/${farmId}`, data)
    return response.data.data
  },

  delete: async (farmId: string): Promise<void> => {
    await apiClient.delete(`/farms/${farmId}`)
  },

  listMembers: async (farmId: string): Promise<FarmMemberResponse[]> => {
    const response = await apiClient.get<{ data: FarmMemberResponse[] }>(`/farms/${farmId}/members`)
    return response.data.data || []
  },
}
